module.exports = __webpack_public_path__ + "img/portrait.523a10d3.jpg";